'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_localization_AppLocale() {
}
export { $c_Lapp_localization_AppLocale as $c_Lapp_localization_AppLocale };
$p = $c_Lapp_localization_AppLocale.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_localization_AppLocale;
/** @constructor */
function $h_Lapp_localization_AppLocale() {
}
export { $h_Lapp_localization_AppLocale as $h_Lapp_localization_AppLocale };
$h_Lapp_localization_AppLocale.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
function $isArrayOf_Lapp_localization_AppLocale(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k2)));
}
export { $isArrayOf_Lapp_localization_AppLocale as $isArrayOf_Lapp_localization_AppLocale };
//# sourceMappingURL=app.localization.-App-Locale.js.map
